import { formatInTimeZone } from 'date-fns-tz'
import { DotsThreeIcon, InfoIcon, Megaphone } from '@phosphor-icons/react'
import ReactTooltip from 'react-tooltip'

import { DropdownMenu } from '@/components/ui/dropdown-menu'
import i18n from '@/i18n'

export const chatSystemNumberTableRows = (data) => [
  {
    createdAt: data.createdAt,
    id: 1,
    name: i18n.t('chat:systemNumbers.announcementsName'),
    tip: i18n.t('chat:systemNumbers.announcementsTip'),
    phone: data.phone,
    phoneSubscriptionBillingDate: data.phoneSubscriptionBillingDate,
    phoneSubscriptionStatus: data.phoneSubscriptionStatus,
  },
]

export const chatSystemNumberTableColumns = (timezone, handleAction) => {
  return [
    {
      Header: i18n.t('chat:systemNumbers.name'),
      Cell: (data) => {
        const { name, tip } = data.row.original

        return (
          <div
            className="system-number-table-cell"
            key={`${data.row.original.id}-${data.row.original.phone}`}
          >
            <div className="inbox-icon-container">
              <Megaphone size={24} />
            </div>
            <div className="name">
              {name}
              {tip ? (
                <div className="name-tip-container" data-tip data-for="name-tip">
                  <InfoIcon size={20} />
                  <ReactTooltip multiline id="name-tip" place="right" effect="solid">
                    {tip}
                  </ReactTooltip>
                </div>
              ) : null}
            </div>
          </div>
        )
      },
    },
    {
      Header: i18n.t('chat:systemNumbers.phoneNumber'),
      Cell: (data) => {
        const phone = data.row.original.phone ? data.row.original.phone : '-'
        return (
          <div
            className="system-number-table-cell"
            key={`${data.row.original.id}-${data.row.original.phone}`}
          >
            <div className="phone-number">{phone}</div>
          </div>
        )
      },
    },
    {
      Header: i18n.t('chat:systemNumbers.createdAt'),
      Cell: (data) => {
        const { createdAt } = data.row.original
        return createdAt ? `${formatInTimeZone(createdAt, timezone, 'd MMM, yyyy - h:mm a')}` : '-'
      },
    },
    {
      Header: '  ',
      Cell: (data) => {
        return (
          // NOTE: Using `DropdownMenu` to fix the issue of scrollable dropdown within the table of the old UI
          <DropdownMenu
            items={[
              {
                label: i18n.t('chat:systemNumbers.settings'),
                onClick: () => handleAction({ data: data.row.original, mode: 'settings' }),
              },
            ]}
            trigger={() => (
              <div
                className="icon-container"
                style={{
                  width: 130,
                  border: '1px solid #EFEFEF',
                  padding: '10px 5px',
                  background: '#FBFBFB',
                  borderRadius: 4,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                  }}
                >
                  <span style={{ marginRight: 10 }}>{i18n.t('chat:systemNumbers.actions')}</span>
                  <DotsThreeIcon size={20} weight="bold" />
                </div>
              </div>
            )}
          />
        )
      },
    },
  ]
}
